module.exports = __webpack_public_path__ + "lp/img/mic_icn-blue.14c60bd7.svg";